// oxlint-disable-next-line typescript/consistent-type-imports
import RouterService from '@ember/routing/router-service';
import { useEmberService } from '@qonto/react-migration-toolkit/react/hooks';
import { useCallback, useMemo, useSyncExternalStore } from 'react';
import { type Location, parsePath } from 'react-router';

export function useEmberLocation(): Location {
  // the services registry is not filled here, hence the ugly cast.
  // oxlint-disable-next-line @repo/no-use-ember-service-router, typescript/consistent-type-assertions
  const emberRouter = useEmberService('router') as RouterService;

  const subscribe: (callback: () => void) => () => void = useCallback(
    callback => {
      emberRouter.addObserver('currentURL', callback);
      return () => emberRouter.removeObserver('currentURL', callback);
    },
    [emberRouter]
  );

  const url = useSyncExternalStore(subscribe, () => emberRouter.currentURL);

  return useMemo(() => {
    const path = parsePath(url);
    return {
      hash: path.hash ?? '',
      key: '',
      pathname: path.pathname ?? '/',
      search: path.search ?? '',
      state: undefined,
    };
  }, [url]);
}
